/*
 * Copyright (C) 2023 - present Marek Kuzora - All Rights Reserved.
 */


export default class
{
  onInstallCreate (status)
  {
    // no-op.
  }


  onInstallUpgrade (status)
  {
    // no-op.
  }


  onInstallIdle (status)
  {
    // no-op.
  }


  onInstallDisband (status)
  {
    // no-op.
  }


  onInstallSetup (status)
  {
    // no-op.
  }


  onInstallActive (status)
  {
    // no-op.
  }


  onInstallCooldown (status)
  {
    // no-op.
  }


};
